import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import ReportTimeReportingSummary_Settings from "./settings";
import {ReportConfig} from "../../../@types";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportTimeReportingSummary extends Report<ReportTimeReportingSummary_Settings> {

    static reportName   : string = "Time reporting status"

    declare settings    : ReportTimeReportingSummary_Settings

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_TIME_REPORTING_SUMMARY
        super(data);

        this.icon        = "isvg-time-reporting" // "isvg-time-summary"
        // this.description = "Summarized data of tracked time."
        this.description = "Displays reported hours per user within a selected period, highlighting compliance with minimum reporting requirements."

        this.settings    = new ReportTimeReportingSummary_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView):ReportTimeReportingSummary {
        return new ReportTimeReportingSummary(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTimeReportingSummary_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        console.error("ZOPA - a eto tut ne mozet uzat'sya ? or what ???")
        // this.settings.projectId = projectId
    }
}



